import React from 'react';
import { applyComponentTheme } from '../../../../theme';
import { TextInputProps } from '../../TextInput';
import { InputComponent } from '../../inputTypes';
import NarrowTextInput from '../NarrowTextInput';

const DayInput: InputComponent<Omit<
  TextInputProps,
  'numbersOnly' | 'maxLength' | 'placeholder'
>> = (props) => <NarrowTextInput {...props} numbersOnly maxLength={2} placeholder="DD" />;

export default applyComponentTheme(DayInput, 'DayInput');
